import { dispatchEvent } from "modules/eventsManager"
import { error, log } from "modules/logs"
import utils from "../utils"
import { CHANNELS, REPONSE_TYPE, ROUTES } from "./communicationTypes"

let requestPort
let requestPortResolver
let isMockMode
let userClientDescriptor

const requestPortPromise = new Promise(r => (requestPortResolver = r))
const eventsSubscribers = {};

const promises = {}

export function getClientDescriptor() {
  return userClientDescriptor || {}
}

function isMockEvent(event) {
    return isMockMode && event?.detail?.mockEvent;
}

function parseEventData(event) {
  if (isMockEvent(event)) {
    return {
            data: event.detail.mockEvent, ports: [{
                postMessage: () => { }
            }]
    }
  }

  if (typeof event.data !== "string") {
        return undefined;
  }

    return event;
}

export async function init(initActions, mockMode) {
    isMockMode = mockMode;
  if (!isMockMode && !utils.isNativeWebview()) {
        return;
  }

    return new Promise(async (resolve) => {
    window.addEventListener("message", async event => {
            const eventData = parseEventData(event);

      if (!eventData) {
                return;
      }

      log(`native > web | raw msg: ${JSON.stringify(eventData.data)}`)

      try {
        const { communicationChannelName, messageContent } = JSON.parse(
          eventData.data
        )

        if (communicationChannelName !== CHANNELS.MAIN)
          throw new Error("Unknown communication channel")

        const { route, requestId, data, success, err } = messageContent
        log(`native > web | ${JSON.stringify(messageContent)}`)

        if (route === ROUTES.INIT) {
          await handleCommunitcationInit(eventData, messageContent, initActions)
                    return resolve();
        }

        if (requestId === "none") {
          // Do nothing
          // Used for calls we don't care about the response from
        }

        const [type, id] = requestId.split(":") // "event:appDeliveryStatus" / "callback:packagesStatus"
        if (type === REPONSE_TYPE.EVENT) {
          // Used for init sequence
                    notifySubscribers(id);

          // Dispatch events to the rest of the app
          dispatchEvent(id, data)
        } else if (type === REPONSE_TYPE.CALLBACK) {
          // Handle responses for promises
          respondToPendingPromise(route, requestId, err, data)
        } else if (!success) {
          const { code, msg } = err
          error(`native > web | code: ${code}, msg: ${msg}`)
        } else {
          error(`native > web | Unknown request type: ${type}`)
        }
      } catch (e) {
        log(e.message)
      }
    })
  })
}

function notifySubscribers(id) {
  if (!eventsSubscribers[id]) {
        log(`no subscribers for event ${id}`);
        return;
  }
    eventsSubscribers[id].forEach((handler) => handler());
}

async function handleCommunitcationInit(
  event,
  { apiVersion, clientDescriptor },
  initActions
) {
  log(
    `native > web | init flow. apiVersion: ${apiVersion} | cd: ${JSON.stringify(
      clientDescriptor
    )}`
  )

    userClientDescriptor = clientDescriptor;

  requestPort = event.ports[0]
  requestPortResolver()

  try {
        await initActions();

    log("native > web | init completed successfully")
  } catch (e) {
    error(`native > web | error: ${e}`)
  }
}

function respondToPendingPromise(route, requestId, err, data) {
  if (requestId && promises[requestId]) {
        const parsedData = JSON.stringify(data);
        const parsedError = JSON.stringify(err);
    log(
      `native > web | response to async call | route: ${route} requestId: ${requestId} | data: ${parsedData} | error: ${parsedError}`
    )

        const promise = promises[requestId];

    if (err) {
      promise.reject(err)
      promises[requestId] = null
            return;
    }

    if (!promise.condition) {
      promise.resolve(data)
      promises[requestId] = null
            return;
    }

    //promise has condition for resolving
        log(`found condition for promise resolving for route: ${route}, requestId: ${requestId}`);
    const conditionMatch = promise.condition(data)
    if (conditionMatch) {
            log(`condition matched. resolving. route: ${route}, requestId: ${requestId}`);
            promise.resolve(data);
            promises[requestId] = null;

    } else {
            log(`condition is not matched. ignoring. route: ${route}, requestId: ${requestId}`);
    }
  }
}

export async function send(route, requestId = '', data, responseCondition) {
  if (!requestId || !promises[requestId]) {
    log(
      `web > native | route: "${route}" | requestId: ${requestId}" | data: "${JSON.stringify(
        data
      )}" | hasCondition: ${!!responseCondition}`
    )
  }

  if (!requestId) {
    if (!requestPort) {
      log("No request port, waiting for requestPort to be created")
      await requestPortPromise
    }
    requestPort.postMessage(JSON.stringify({ route, requestId, data }))
    return
  }

  if (!promises[requestId]) {
    promises[requestId] = {}

    promises[requestId].promise = new Promise(async (resolve, reject) => {
      promises[requestId].resolve = resolve
      promises[requestId].reject = reject
      if (responseCondition) {
                promises[requestId].condition = responseCondition;
      }

      if (!requestPort) {
        log("No request port, waiting for requestPort to be created")
        await requestPortPromise
      }
      requestPort.postMessage(JSON.stringify({ route, requestId, data }))
    })
  } else {
    log(
      `web > native | route: ${route} | requestId: ${requestId} | already requested`
    )
  }
  return promises[requestId].promise
}

export function streamSubscribe(route, eventName, data, handler) {
  const requestId = `event:${eventName}`
  log(
    `web > native | route: "${route}" | requestId: ${requestId}" | data: "${JSON.stringify(
      data
    )}"`
  )

  eventsSubscribers[eventName] = eventsSubscribers[eventName]
    ? eventsSubscribers[eventName]
    : []
  eventsSubscribers[eventName].push(handler)


  requestPort.postMessage(
    JSON.stringify({
      route,
      requestId,
      data,
    })
  )
}

export async function permissionsStatus(permission) {
  // Request: permission \
  // Response: result (granted/denied)
  return send("permission/status", `callback:permissionStatus_${permission}`, {
    permission, // "notification", "install"
  })

  // status = {permission: "notification", type: "granted"}
}

export async function permissionRequest(permission) {
  // Request: permission \
  // Response: result (requested/granted/denied)
    return send("permission/grant", `callback:permissionGrant_${permission}`, {
      permission, // "notification", "install"
    }, (installPermissionRes) => {
        log(`install Permission Result: ${JSON.stringify(installPermissionRes)}`);
        return ["granted", "denied"].includes(installPermissionRes.status.type);
    })
}

export function isEnabled() {
    return isMockMode
        ? true
        : utils.isNativeWebview();
}